/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).ready(function(){
  
  ///monysymbole
  
  var symbol = theme.moneyFormat.split('{')[0];
  
  
  
  
  $(document).on("click", ".selector-wrapper .single-option-selector .bcpo-image-parent , .selector-wrapper .single-option-selector .bcpo-button-parent, .selector-wrapper input", function() { 
    setTimeout(function(){
      
      //var matter = $('.bcpo-price-addons .bcpo-addons-price').html().substring(1);
      
      
      var matter = $('.bcpo-price-addons .bcpo-addons-price').html();
      
      
      var texttt = ""+symbol+"0.00";
      
      if (matter == texttt) {
        $('.change_price').html(''); 
      }
      else{
        $('.change_price').html('(+'+matter+')'); 
      }
      
      
    },500);
  });
  
  $(document).on("change", ".selector-wrapper select", function(){ 
    setTimeout(function(){
      
      var matter = $('.bcpo-price-addons .bcpo-addons-price').html();
      
      var texttt = ""+symbol+"0.00";

      if (matter == texttt) {
        $('.change_price').html(''); 
      }
      else{
        $('.change_price').html('(+'+matter+')'); 
      }
      
    },500);
  });
  
});





/*===== get stock in outstock ==================*/




$(document).ready(function(){

  $(document).on("click", ".selector-wrapper .single-option-selector .bcpo-image-parent , .selector-wrapper", function() { 		

    setTimeout(function(){

      var pageURL = $(location).attr("href");

      var getprodid = pageURL.substring(pageURL.lastIndexOf('=') + 1);

      $('.itg_ck_sellect option').each(function(){

        var getval = $(this).val();

        if (getprodid == getval) {

          var qtyget = $(this).data('qty');

          if(qtyget <= 0) {

            $('.change_hide').hide();
            $('.hide_ck_stock').hide();

            $('.hide_ck_outstock').show();

          }

          else{

            $('.change_hide').hide();
            $('.hide_ck_outstock').hide();

            $('.hide_ck_stock').show();

          }

        }


      });

    }, 300);

  });

});
